<template>
    <div v-if="status !== 0">
        <v-progress-linear
                v-if="status === 1"
                color="primary"
                indeterminate
        ></v-progress-linear>
        <api-errors-viewer :errors="data" v-if="status === 3"></api-errors-viewer>
        <v-card class="v-card-profile" v-if="status === 2">
            <v-card-text class="text-xs-center">
                <h1>{{this.$t("device_title")}}</h1>
                <h2 class="font-weight-light">{{device.name}} (@{{device.deviceName}})</h2>
                <v-btn
                        color="error"
                        round
                        class="font-weight-light"
                        :disabled="device.deviceName === current_device_name"
                        @click="unsubscribeHandler()">
                    {{this.$t('unsubscribe_btn_text')}}
                </v-btn>
                <subscription-qr-viewer
                        v-if="device.deviceName === current_device_name"
                        :device-data="this.$store.getters.getDevice">
                </subscription-qr-viewer>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import ApiErrorsViewer from './api/APIErrorsViewer'
    import SubscriptionQrViewer from "./SubscriptionQrViewer";
    export default {
        name: "DeviceProfileViewer",
        data() {
           return {
               status_internal: false,
           }
        },
        props: ['data', 'device', 'current_device_name', 'unsubscribeHandler'],
        computed: {
            status() {
                if(parseInt(this.data) === 0) return 0
                if(parseInt(this.data) === 1) return 1
                if(parseInt(this.data) === 2) return 2
                return 3
            }
        },
        components: {
            SubscriptionQrViewer,
            ApiErrorsViewer
        }
    }
</script>

<style scoped>
</style>

<i18n>
    {
        "en": {
            "device_title": "Device",
            "unsubscribe_btn_text": "Unsubscribe"
        },
        "es": {
            "device_title": "Dispositivo",
            "unsubscribe_btn_text": "Darse de baja"
        }
    }
</i18n>